<template>
  <!-- 信息 -->
  <div class="patientVisits-order-info">
    <div class="info">
      <div>
        <p>
          <label>医生姓名: </label><span>{{ doctorInfo.doctor_name }}</span>
        </p>
        <p>
          <label>性别: </label><span>{{ doctorInfo.sex | sexFilter }}</span>
        </p>
        <p>
          <label>年龄: </label><span>{{ doctorInfo.age }}</span>
        </p>
      </div>

      <div>
        <p>
          <label>手机号: </label><span>{{ doctorInfo.phone }}</span>
        </p>
      </div>

      <div>
        <p>
          <label>职称: </label><span>{{ doctorInfo.title }}</span>
        </p>
        <p>
          <label>科室: </label><span>{{ doctorInfo.department_name }}</span>
        </p>
        <p>
          <label></label><span></span>
        </p>
      </div>

      <div>
        <p>
          <label>医院名称: </label><span>{{ doctorInfo.hospital }}</span>
        </p>
      </div>
    </div>
    <div class="info">
      <div>
        <p>
          <label>患者姓名: </label><span>{{ userInfo.real_name }}</span>
        </p>
        <p>
          <label>性别: </label><span>{{ userInfo.sex | sexFilter }}</span>
        </p>
        <p>
          <label>年龄: </label><span>{{ userInfo.age }}</span>
        </p>
      </div>

      <div>
        <p>
          <label>手机号: </label><span>{{ userInfo.phone }}</span>
        </p>
        <p>
          <label>用户昵称: </label><span>{{ userInfo.nick_name }}</span>
        </p>
        <p>
          <label></label><span></span>
        </p>
      </div>

      <div>
        <p>
          <label>既往病史: </label><span>{{ userInfo.history_name }}</span>
        </p>
      </div>
      <div>
        <p>
          <label>过敏历史: </label><span>{{ userInfo.allergen_name }}</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    doctorInfo: {
      require: true,
      type: Object,
      default: function () {
        return {};
      }
    },
    userInfo: {
      require: true,
      type: Object,
      default: function () {
        return {};
      }
    }
  },
  filters: {
    sexFilter(val) {
      switch (val) {
        case 0:
          return '未知';
        case 1:
          return '男';
        case 2:
          return '女';
      }
    }
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
.patientVisits-order-info {
  display: flex;
  justify-content: space-around;
  margin-bottom: 20px;
  & > div {
    width: 46%;
    min-height: 200px;
    background-color: #f2f2f2;
  }
  .info {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    & > div {
      padding: 0 20px;
      display: flex;
      align-items: center;
      max-height: 40px;
      flex-wrap: wrap;
      align-items: flex-start;
      align-content: flex-start;
      justify-content: space-between;
      & > p {
        // padding: 0 60px 0 20px;
        margin: 0;
        padding: 0;
        display: flex;
        align-items: center;
        label {
          font-weight: bold;
          font-size: 15px;
          text-align: left;
          margin-right: 10px;
          white-space: nowrap;
        }
        span {
          text-align: left;
        }
      }
    }
  }
}
</style>